export function NewRegistrationBadge() {
  return (
    <div className="bg-emerald-300 font-bold leading-[6px] px-xs py-1 rounded-full text-primary text-[8px] uppercase w-fit">
      new
    </div>
  );
}
